import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const footerSections = [
    {
      title: 'FOR CUSTOMER',
      links: [
        // { text: 'Ways to Fly', href: '/ways-to-fly', isRoute: true },
        { text: 'FAQ', href: '/faq', isRoute: true },
        { text: 'Blog', href: '/blog', isRoute: true }
      ]
    },
    {
      title: 'COMPANY',
      links: [
        { text: 'About Us', href: '/about-us', isRoute: true },
        { text: 'Contact Us', href: '/contact-us', isRoute: true },
        { text: 'Investor Relations', href: '/investor-relations', isRoute: true }
      ]
    },
    {
      title: 'LEGAL',
      links: [
        { text: 'Terms & Conditions', href: '/terms-and-conditions', isRoute: true },
        { text: 'Privacy Policy', href: '/privacy-policy', isRoute: true },
        { text: 'Refund & Cancellation', href: '/refund-and-cancellation', isRoute: true },
        { text: 'Safety & Security', href: '/safety-and-security', isRoute: true },
        { text: 'Cookie Policy', href: '/cookie-policy', isRoute: true }
      ]
    }
  ];

  return (
    <>
      {/* Main Footer Section */}
      <footer className="py-8 bg-white">
        <div className="w-[86%] mx-auto px-3 sm:px-5">
          <div className="flex flex-col lg:flex-row justify-between gap-8">
            {/* Footer Links Sections */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 flex-1">
              {footerSections.map((section, index) => (
                <div key={index} className="footer-section">
                  <h6 className="text-xs font-semibold text-jet-primary mb-4 tracking-wide uppercase">{section.title}</h6>
                  <ul className="space-y-2 list-unstyled mb-0 footer_active-class">
                    {section.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        {link.isRoute ? (
                          <Link 
                            to={link.href} 
                            className="text-jet-primary text-sm hover:text-jet-orange transition-colors duration-200"
                          >
                            {link.text}
                          </Link>
                        ) : (
                          <a 
                            href={link.href} 
                            className="text-jet-primary text-sm hover:text-jet-orange transition-colors duration-200"
                          >
                            {link.text}
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            
            {/* App Store Badges and Social Icons */}
            <div className="flex flex-col items-center lg:items-end gap-6">
              {/* App Store Badges */}
              <div className="flex flex-col gap-4">
                <a href="#" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
                  <i className="fab fa-apple text-black text-4xl"></i>
                  <div>
                    <div className="text-[11px] text-black leading-tight">Available on the</div>
                    <div className="text-xl font-semibold text-black leading-tight">App Store</div>
                  </div>
                </a>
                <a href="#" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
                  {/* Google Play icon - 4 colored triangles */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24">
                    <path d="M3 20.5v-17c0-.83 1-.83 1.5-.5l15 8.5-15 8.5c-.5.33-1.5.33-1.5-.5z" fill="none"/>
                    <polygon points="3,1.5 14.5,12 3,22.5" fill="#00BCD4"/>
                    <polygon points="3,1.5 14.5,12 19.5,9.2" fill="#4CAF50"/>
                    <polygon points="3,22.5 14.5,12 19.5,14.8" fill="#F44336"/>
                    <polygon points="14.5,12 19.5,9.2 22,10.6 22,13.4 19.5,14.8" fill="#FFC107"/>
                  </svg>
                  <div>
                    <div className="text-[11px] text-black leading-tight uppercase tracking-wide">GET IT ON</div>
                    <div className="text-xl font-semibold text-black leading-tight">Google Play</div>
                  </div>
                </a>
              </div>
              
              {/* Social Icons */}
              <div className="flex gap-3">
                <div className="w-8 h-8 bg-gray-300 rounded-full hover:bg-gray-400 transition-colors duration-200 cursor-pointer"></div>
                <div className="w-8 h-8 bg-gray-300 rounded-full hover:bg-gray-400 transition-colors duration-200 cursor-pointer"></div>
                <div className="w-8 h-8 bg-gray-300 rounded-full hover:bg-gray-400 transition-colors duration-200 cursor-pointer"></div>
                <div className="w-8 h-8 bg-gray-300 rounded-full hover:bg-gray-400 transition-colors duration-200 cursor-pointer"></div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      
      {/* Copyright Section - Separate */}
      <div className="bg-white border-t border-gray-300 py-4">
        <div className="w-[86%] mx-auto px-3 sm:px-5">
          <p className="text-gray-600 text-sm text-center">
            Copyright © 2026, JetScanner360. All Rights Reserved.
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;